import React from 'react';
import { func, string, bool } from 'prop-types';

import Icon from 'components/icon';

const FiltersTriggerButton = ({ disabled, onClick, title }) => {
    if (!title) {
        return null;
    }
    return (
        <div className="filters-trigger-button-container">
            <button
                className="filters-trigger-button"
                disabled={disabled}
                onClick={onClick}
                type="button"
            >
                <span className="filters-trigger-button__text">{title}</span>
                <Icon glyph="filter" />
            </button>
        </div>
    );
};

FiltersTriggerButton.propTypes = {
    disabled: bool,
    onClick: func,
    title: string.isRequired
};

export default FiltersTriggerButton;
